import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import UIFlex from 'UIComponents/layout/UIFlex';
import { BackButton } from '../../navigation';
import styled, { css, mediaQuery, useMediaQuery } from '../../../utils/Styling';
import UIBox from 'UIComponents/layout/UIBox';
import DividedList from '../../../components/DividedList';
import { PlaylistAssignmentsAssignedByFilter, PlaylistAssignmentsMobileFilter } from '..';
import { TopFilters } from '../../filters';
import { H4, H5 } from 'UIComponents/elements/headings';
const TopFiltersContainer = styled(UIFlex).withConfig({
  displayName: "PlaylistAssignmentsTablePage__TopFiltersContainer",
  componentId: "sc-1mueep2-0"
})([".top-filters-bar{padding:12px 0;margin:0;}.search-input{margin-top:4px;}"]);
const StyledBackButton = styled(BackButton).withConfig({
  displayName: "PlaylistAssignmentsTablePage__StyledBackButton",
  componentId: "sc-1mueep2-1"
})(["position:absolute !important;transform:translateX(-4px) translateY(-40px);", ""], mediaQuery('mobile', css(["transform:translateX(-4px) translateY(-28px);"])));

const PlaylistAssignmentsTablePage = ({
  children,
  headerTitle,
  backButton,
  tableCount,
  enabledFilters,
  actions
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const Heading = isMobile ? H5 : H4;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [backButton && /*#__PURE__*/_jsx(StyledBackButton, {
      exact: true,
      to: backButton.to,
      children: backButton.title
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: isMobile ? 'column' : 'row',
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        style: {
          width: '100%'
        },
        children: [/*#__PURE__*/_jsxs(UIBox, {
          grow: 1,
          children: [/*#__PURE__*/_jsx(Heading, {
            className: "m-bottom-1",
            children: headerTitle
          }), /*#__PURE__*/_jsxs(DividedList, {
            className: "m-bottom-2",
            children: [tableCount, !isMobile && /*#__PURE__*/_jsx(PlaylistAssignmentsAssignedByFilter, {})]
          })]
        }), isMobile && /*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsx(PlaylistAssignmentsMobileFilter, {})
        })]
      }), /*#__PURE__*/_jsx(UIBox, {
        style: {
          width: '100%'
        },
        children: /*#__PURE__*/_jsxs(TopFiltersContainer, {
          gap: 6,
          justify: "end",
          children: [/*#__PURE__*/_jsx(TopFilters, {
            enabledFilters: enabledFilters,
            showClearButton: false,
            showLabel: false,
            showTags: false
          }), actions]
        })
      })]
    }), children]
  });
};

export default PlaylistAssignmentsTablePage;